"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileTextOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<polygon points="9.39 22.16 10.79 22.16 10.79 18.04 12.1 18.04 12.1 16.83 8.08 16.83 8.08 18.04 9.39 18.04 9.39 22.16"/><polygon points="14.97 22.16 16 20.48 17.03 22.16 18.71 22.16 16.93 19.54 18.62 16.83 16.93 16.83 16 18.51 15.06 16.83 13.48 16.83 15.16 19.45 13.38 22.16 14.97 22.16"/><polygon points="21.21 22.16 22.61 22.16 22.61 18.04 23.92 18.04 23.92 16.83 19.9 16.83 19.9 18.04 21.21 18.04 21.21 22.16"/><path d="M28,13H27V9.43a1,1,0,0,0-.29-.71L20.3,2.29A1,1,0,0,0,19.59,2H6A1,1,0,0,0,5,3V13H4a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2H5v3a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V26h1a2,2,0,0,0,2-2V15A2,2,0,0,0,28,13ZM24.16,9H20V4.83ZM7,4H18v6a1,1,0,0,0,1,1h6v2H7ZM25,28H7V26H25Zm3-4H4V15H28Z"/>';
var FileTextOutlineSVG = function FileTextOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FileTextOutlineSVG = FileTextOutlineSVG;
FileTextOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FileTextOutlineSVG);
exports.default = _default;